/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconExternalLink extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "ExternalLinkIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' viewBox="0 0 1792 1536" id="svg14"><path d="m 1408,928 v 320 q 0,119 -84.5,203.5 Q 1239,1536 1120,1536 H 288 Q 169,1536 84.5,1451.5 0,1367 0,1248 V 416 Q 0,297 84.5,212.5 169,128 288,128 h 704 q 14,0 23,9 9,9 9,23 v 64 q 0,14 -9,23 -9,9 -23,9 H 288 q -66,0 -113,47 -47,47 -47,113 v 832 q 0,66 47,113 47,47 113,47 h 832 q 66,0 113,-47 47,-47 47,-113 V 928 q 0,-14 9,-23 9,-9 23,-9 h 64 q 14,0 23,9 9,9 9,23 z M 1792,64 v 512 q 0,26 -19,45 -19,19 -45,19 -26,0 -45,-19 L 1507,445 855,1097 q -10,10 -23,10 -13,0 -23,-10 L 695,983 q -10,-10 -10,-23 0,-13 10,-23 L 1347,285 1171,109 q -19,-19 -19,-45 0,-26 19,-45 19,-19 45,-19 h 512 q 26,0 45,19 19,19 19,45 z" id="path12"></path></svg>
    `;
}
